import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UiStates } from './ui-states.enum';

export interface IUiState {
    states: UiStates[];
}

export const defaultUiState: IUiState = {
    states: [UiStates.Home],
};

export const uiFeatureKey = 'ui';

export interface IUiRootState {
    ui: IUiState;
}

export const uiStateSelector = createFeatureSelector<IUiState>('ui');

export const isSheetViewOpen = createSelector(uiStateSelector, (ui: IUiState) => ui.states.some((state) => state === UiStates.SheetViewOpened));
